<template>
  <transition name="slide-fade">
    <div class="detalles-medico col-12 col-lg-4">
      <AlertaMsj :alerta-msj="alertaMsj" />
      <section>
        <router-link
          :to="{name:'SolicitudesModulo',
                params:{modulo: $route.params.modulo}}"
          class="d-inline-block d-lg-block"
        >
          <font-awesome-icon
            class="mr-2"
            :icon="['fas', 'chevron-left']"
          />
          Atrás
        </router-link>
        <header class="font-weight-bold mt-n4 text-center float-lg-right">
          Solicitud Médico
        </header>
        <div class="row mt-3">
          <div class="col-12 col-sm-6 col-lg-12 mb-2">
            <small class="d-block text-muted text-uppercase">
              Solicitante
            </small>
            {{ doctor.doctor.prename }}
            {{ doctor.doctor.fname }} {{ doctor.doctor.mname }}
            {{ doctor.doctor.lname }} {{ doctor.doctor.llname }}
            {{ doctor.doctor.posname }}
          </div>
          <div class="col-12 col-sm-6 col-lg-12 mb-2">
            <small class="d-block text-muted text-uppercase">
              Identificación
            </small>
            {{ doctor.doctor.identificationType }} -
            {{ doctor.doctor.identification }}
          </div>
          <div class="col-7 col-sm-6 col-md-4 col-lg-7 col-lg-7 mb-2">
            <small class="d-block text-muted text-uppercase">
              Fecha de nacimiento
            </small>
            {{ doctor.doctor.born.day > 9
              ? doctor.doctor.born.day
              : '0' + doctor.doctor.born.day
            }}/{{
              doctor.doctor.born.month > 9
                ? doctor.doctor.born.month
                : '0' + doctor.doctor.born.month
            }}/{{ doctor.doctor.born.year }}
          </div>
          <div class="col-5 col-sm-6 col-md-4 col-lg-5 col-lg-5 mb-2">
            <small class="d-block text-muted text-uppercase">
              Género
            </small>
            {{ doctor.doctor.gender }}
          </div>
          <div class="col-6 col-md-4 col-lg-12 mb-2">
            <small class="d-block text-muted text-uppercase">
              Estatus
            </small>
            {{ doctor.status }}
          </div>
          <div class="col-6 col-md-4 col-lg-12 mb-2">
            <small class="d-block text-muted text-uppercase">
              Fecha solicitud
            </small>
            {{ doctor.createdAt.formatted }}
          </div>
          <div
            v-if="doctor.invitationCode"
            class="col-6 col-md-4 col-lg-12 mb-2">
            <small class="d-block text-muted text-uppercase">
              Invitado por
            </small>
            {{ doctor.invitationCode }}
          </div>
          <div class="col-12 col-sm-6 col-lg-12 mb-2">
            <small class="d-block text-muted text-uppercase">
              Teléfonos
            </small>
            <ul
              v-if="doctor.doctor.tels && doctor.doctor.tels.length"
              class="list-unstyled mb-0"
            >
              <li
                v-for="tel in doctor.doctor.tels"
                :key="tel.number"
              >
                <a
                  :href="`tel:+${tel.country}${tel.number}`"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-break"
                >
                  +{{ tel.country }} {{ tel.number }}
                </a>
                <a
                  :href="`https://wa.me/${tel.country}${tel.number}`"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-break ml-2"
                >
                  WA
                </a>
              </li>
            </ul>
            <span class="text-muted">
              No hay teléfonos registrados
            </span>
          </div>
          <div class="col-12 col-sm-6 col-lg-12 mb-2">
            <small class="d-block text-muted text-uppercase">
              Emails
            </small>
            <a
              v-for="e in doctor.doctor.emails"
              :key="e.email"
              :href="`mailto:${e.email}`"
              target="_blank"
              rel="noopener noreferrer"
              class="d-block text-break"
            >
              {{ e.email }}
            </a>
          </div>
        </div>
        <header class="mt-2 mb-1 font-weight-bold text-center">
          Información académica
        </header>
        <div
          v-for="(degree, index) in doctor.doctor.degrees"
          :key="index"
          class="row mb-3"
        >
          <p class="col-12 col-sm-6 col-md-4 col-lg-12 mb-2">
            <small class="d-block text-muted text-uppercase">
              Especialidad
            </small>
            {{ degree.name }}
          </p>
          <p class="col-12 col-sm-6 col-md-3 col-lg-12 mb-2">
            <small class="d-block text-muted text-uppercase">
              Matrícula
            </small>
            {{ degree.code }}
          </p>
          <!-- Instituto -->
          <p class="col-12 col-md-5 col-lg-12 mb-2">
            <small class="d-block text-muted text-uppercase">
              Instituto
            </small>
            <span v-if="degree.career && degree.career.institute">
              {{ degree.career.institute.name }}
            </span>
            <span
              v-else
              class="text-muted"
            >
              Sin información
            </span>
          </p>
        </div>
        <section class="requisitos">
          <header>
            Requisitos
          </header>
          <div class="d-justify-between2">
            <div
              v-for="doc in documentos"
              :key="doc.name"
            >
              <div
                class="our-checkbox d-inline-block"
              >
                <input
                  :id="doc.name"
                  v-model="doc.path"
                  type="checkbox"
                  disabled
                >
                <label :for="doc.name">
                  {{ doc.name }}
                </label>
              </div>
              <div
                v-if="doc.path"
                class="md-form md-outline outline-select my-1 mx-2"
              >
                <select
                  :id="`${doc.name}-select`"
                  v-model="doc.status"
                  class="custom-select custom-select-sm"
                  @change="updateDocument(doc)"
                >
                  <option
                    class="d-none"
                    value=""
                    disabled
                  >
                    Seleccione
                  </option>
                  <option value="Revisado">
                    Revisado
                  </option>
                  <option value="Pendiente">
                    Pendiente
                  </option>
                  <option value="Rechazado">
                    Rechazado
                  </option>
                </select>
              </div>
            </div>
          </div>
          <!-- Sugerencia: Se puede agregar un color al estatus -->
          <span v-if="doctor.documents[0] && doctor.documents[0].status">
            Estatus de la solicitud:
            {{ doctor.documents[0].status }}
          </span>
          <div
            class="d-flex justify-content-center"
          >
            <mdb-btn
              class="py-2 px-3"
              color="success"
              icon="check"
              @click="grantAccess"
            >
              Aprobar
            </mdb-btn>
            <mdb-btn
              class="py-2 px-3"
              color="warning"
              icon="ban"
              @click="esNegarSolicitud = true; showConfirmation = true"
            >
              Denegar
            </mdb-btn>
            <mdb-btn
              class="py-2 px-3"
              color="danger"
              icon="trash"
              @click="showConfirmation = true"
            >
              Eliminar
            </mdb-btn>
          </div>
        </section>
        <section class="messages">
          <header>
            Enviar mensaje
          </header>
          <form
            class="mb-4"
            @submit.prevent="sendMessage"
          >
            <div class="d-justify-between2">
              <div
                v-for="plantilla in plantillas"
                :key="plantilla.id"
                class="our-radio1"
              >
                <input
                  :id="`radio-${plantilla.id}`"
                  v-model="messageToSend"
                  type="radio"
                  name="option"
                  :value="plantilla.content"
                >
                <label :for="`radio-${plantilla.id}`">
                  {{ plantilla.name }}
                </label>
              </div>
              <div class="our-radio1">
                <input
                  id="msg-radio-otro"
                  type="radio"
                  name="option"
                  @click="messageToSend=''"
                >
                <label for="msg-radio-otro">
                  Otro
                </label>
              </div>
            </div>
            <mdb-input
              v-model="messageToSend"
              type="textarea"
              class="my-2"
              label="Nuevo mensaje"
              outline
              :rows="2"
            />
            <div class="d-flex flex-column">
              <mdb-btn
                color="default"
                type="submit"
                class="py-2 px-3 mx-auto"
                :disabled="btnDisabled.sendMessage"
              >
                <font-awesome-icon
                  v-if="btnDisabled.sendMessage"
                  icon="circle-notch"
                  class="mr-1"
                  spin
                  size="lg"
                />
                <font-awesome-icon
                  v-else
                  icon="envelope"
                  class="mr-1"
                  size="lg"
                />
                Enviar
              </mdb-btn>
            </div>
          </form>
        </section>
        <section class="messages">
          <header>
            Historial de mensajes
          </header>
          <div>
            <span
              v-for="(message, index) in doctor.messages"
              :key="index"
              class="double-check-icon"
              :data-date="`${message.date.hour}:${message.date.minute} -
                ${message.date.day}/${message.date.month}/
                ${message.date.year}`"
            >
              {{ message.message }}
            </span>
          </div>
        </section>
        <div
          v-if="doctor.doctor.emailConfirmation"
          class="row"
        >
          https://medico.amii.app/login/{{ doctor.doctor.emailConfirmation }}
        </div>
      </section>
      <!-- Modal confirmación rechazar -->
      <mdb-modal
        centered
        elegant
        :show="showConfirmation"
        @close="showConfirmation = false; esNegarSolicitud = false"
      >
        <mdb-modal-header>
          <mdb-modal-title>
            Se requiere confirmación
          </mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body>
          <p class="text-center px-4 px-sm-5">
            {{
              `Se ${esNegarSolicitud
                ? 'negará la solicitud'
                : 'eliminará el doctor'}`
            }}
            en su totalidad.
            <span
              v-if="esNegarSolicitud"
              class="d-block mt-2 font-weight-bold"
            >
              ¿Estás seguro que deseas negar la solicitud?
            </span>
            <span
              v-else
              class="d-block mt-2 font-weight-bold"
            >
              ¿Estás seguro que deseas eliminar el doctor?
            </span>
          </p>
          <div class="row justify-content-around">
            <mdb-btn
              flat
              waves
              :icon="btnDisabled.denyAccess ? 'circle-notch' : 'times'"
              :icon-class="btnDisabled.denyAccess ? 'fa-spin' : ''"
              :disabled="btnDisabled.denyAccess"
              class="col-auto btn-bordeado px-4"
              @click="showConfirmation = false; esNegarSolicitud = false"
            >
              No
            </mdb-btn>
            <mdb-btn
              color="danger"
              :icon="btnDisabled.denyAccess ? 'circle-notch' : 'check'"
              :icon-class="btnDisabled.denyAccess ? 'fa-spin' : ''"
              :disabled="btnDisabled.denyAccess"
              class="col-auto px-4"
              @click="esNegarSolicitud ? denyAccess() : deleteUsers()"
            >
              Si
            </mdb-btn>
          </div>
        </mdb-modal-body>
      </mdb-modal>
    </div>
  </transition>
</template>
<script>
import AlertaMsj from '../components/AlertaMsj.vue';
import {
  mdbBtn,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalTitle,
} from 'mdbvue';
import gql from 'graphql-tag';
import userGql from '@/graphql/user.gql';
import sendMessageGql from '@/graphql/sendMessage.gql';
import moduleRequirementsGql from '@/graphql/moduleRequirements.gql';
import documentUpdateGql from '@/graphql/documentUpdate.gql';
import templateGql from '@/graphql/template.gql';
import grantAccessGql from '@/graphql/grantAccess.gql';
import denyAccessGql from '@/graphql/denyAccess.gql';
import deleteUsersGql from '@/graphql/deleteUsers.gql';
export default {
  name: 'SolicitudMedico',
  components: {
    AlertaMsj,
    mdbBtn,
    mdbInput,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalTitle,
  },
  data() {
    return {
      showConfirmation: false,
      esNegarSolicitud: false,
      doctor: {
        doctor: {
          born: {},
          emails: [],
        },
        documents: [],
        createdAt: {
          formatted: '',
        },
      },
      messageToSend: '',
      messageSubject: 'AMII - Departamento de admisión',
      alertaMsj: {
        content: '',
      },
      requisitos: [],
      btnDisabled: {
        sendMessage: false,
        grantAccess: false,
        denyAccess: false,
        deleteUsers: false,
      },
    };
  },
  computed: {
    userId() {
      return this.$route.params.userId;
    },
    documentos() {
      return this.requisitos.map((req) => {
        req = JSON.parse(JSON.stringify(req));
        const name = req.name;
        const doc = this.doctor.documents.filter((d) => {
          return d.requirement.name == req.name;
        });
        Object.assign(req, {...doc[0]});
        req.name = name;
        return req;
      });
    },
  },
  methods: {
    updateDocument(doc) {
      this.$apollo.mutate({
        mutation: gql`${documentUpdateGql}`,
        variables: {
          document: {
            path: doc.path,
            status: doc.status,
          },
        },
      }).then((res) => {
        const msg = res.data.documentUpdate.msg;
        switch (msg) {
          case 'success':
            this.alertaMsj = {
              content: 'Actualizado estatus del documento exitosamente',
              type: 'success',
            };
            break;
          default:
            this.alertaMsj = {
              content: 'Ha fallado la actulización del estatus',
              type: 'danger',
            };
            break;
        }
      }).catch((error) => {
        return this.alertaMsj = {
          content: 'Hubo un error al actualizar el estatus',
          type: 'danger',
        };
      });
    },
    sendMessage() {
      if (!this.messageToSend) {
        return this.alertaMsj = {
          content: 'Debes elegir un mensaje antes de enviar',
          type: 'warning',
        };
      }
      this.btnDisabled.sendMessage = true;
      this.$apollo.mutate({
        mutation: gql`${sendMessageGql}`,
        variables: {
          message: {
            subject: this.messageSubject,
            message: this.messageToSend,
            toUserId: this.userId,
          },
        },
      }).then((res) => {
        const msg = res.data.sendMessage.msg;
        switch (msg) {
          case 'message_sent':
            this.alertaMsj = {
              content: 'Mensaje enviado satisfactoriamente',
              type: 'success',
            };
            break;
          default:
            this.alertaMsj = {
              content: 'Hubo un error al enviar el mensaje al usuario',
              type: 'warning',
            };
            break;
        }
        this.btnDisabled.sendMessage = false;
      }).catch((error) => {
        this.btnDisabled.sendMessage = false;
        return this.alertaMsj = {
          content: 'Hubo un error al enviar el mensaje',
          type: 'danger',
        };
      });
    },
    // Aprobar, denegar solicitudes ó eliminar usuario

    grantAccess() {
      this.btnDisabled.grantAccess = true;
      this.$apollo.mutate({
        mutation: gql`${grantAccessGql}`,
        variables: {
          usersId: [this.$route.params.userId],
          module: this.$route.params.modulo,
        },
      }).then((res) => {
        const msg = res.data.grantAccess.msg;
        switch (msg) {
          case 'success':
            this.$emit('limpiarSolicitudes', [this.$route.params.userId]);
            this.alertaMsj = {
              content: 'El médico ha sido aprobado satisfactoriamente',
              type: 'success',
            };
            break;
          default:
            this.alertaMsj = {
              content: 'Hubo un error al aprobar al médico',
              type: 'danger',
            };
            break;
        }
        this.btnDisabled.grantAccess = false;
      }).catch((error) => {
        this.btnDisabled.grantAccess = false;
        return this.alertaMsj = {
          content: 'Hubo un error'+
            ' al enviar la aprobacion del médico',
          type: 'danger',
        };
      });
    },
    denyAccess() {
      if (this.btnDisabled.denyAccess) return;
      this.btnDisabled.denyAccess = true;
      this.$apollo.mutate({
        mutation: gql`${denyAccessGql}`,
        variables: {
          usersId: [this.$route.params.userId],
          module: this.$route.params.modulo,
        },
      }).then((res) => {
        const msg = res.data.denyAccess.msg;
        switch (msg) {
          case 'success':
            this.$emit('limpiarSolicitudes', [this.$route.params.userId]);
            this.alertaMsj = {
              content: 'El médico ha sido rechazado satisfactoriamente',
              type: 'success',
            };
            this.showConfirmation = false;
            this.$router.go(-1);
            break;
          default:
            this.alertaMsj = {
              content: 'Hubo un error al rechazar al médico',
              type: 'danger',
            };
            break;
        }
        this.btnDisabled.denyAccess = false;
      }).catch((error) => {
        this.btnDisabled.denyAccess = false;
        return this.alertaMsj = {
          content: 'Hubo un error'+
            ' al enviar la denegación del médico',
          type: 'danger',
        };
      });
    },
    deleteUsers() {
      if (this.btnDisabled.deleteUsers) return;
      this.btnDisabled.deleteUsers = true;
      this.$apollo.mutate({
        mutation: gql`${deleteUsersGql}`,
        variables: {
          usersId: [this.$route.params.userId],
        },
      }).then((res) => {
        const msg = res.data.deleteUsers.msg;
        switch (msg) {
          case 'success':
            this.$emit('limpiarSolicitudes', [this.$route.params.userId]);
            this.alertaMsj = {
              content: 'El doctor ha sido eliminado satisfactoriamente',
              type: 'success',
            };
            this.showConfirmation = false;
            this.$router.go(-1);
            break;
          default:
            this.alertaMsj = {
              content: 'Hubo un error al eliminar médico',
              type: 'danger',
            };
            break;
        }
        this.btnDisabled.deleteUsers = false;
      }).catch((error) => {
        this.btnDisabled.deleteUsers = false;
        return this.alertaMsj = {
          content: 'Hubo un error'+
            ' al enviar la solicitud de eliminar médico',
          type: 'danger',
        };
      });
    },
  },
  apollo: {
    doctor() {
      return {
        query: gql`${userGql}`,
        variables() {
          return {
            userId: this.userId,
            module: this.$route.params.modulo,
          };
        },
        update: (data) => data.User[0],
      };
    },
    requisitos() {
      return {
        query: gql`${moduleRequirementsGql}`,
        variables: {
          name: this.$route.params.modulo,
        },
        update: (data) => data.Module[0].requirements,
      };
    },
    plantillas() {
      return {
        query: gql`${templateGql}`,
        update: (data) => data.Template,
      };
    },
  },
};
</script>
<style lang="scss">
  .detalles-medico {
    background-color: white;
    position: fixed;
    right: 0;
    overflow-y: scroll;
    height: calc(100% - 42px);
    margin-top: -14px;
    padding-top: 28px;

    @media (min-width: 992px) {
      padding-top: 40px;
    }

    .requisitos,
    .messages {
      margin: .5rem auto 1rem;

      header {
        font-weight: 600;
        margin-top: .5rem;
        text-align: center;
      }
    }
    .messages textarea.form-control.md-textarea {
      overflow-y: auto !important;
    }

    .d-justify-between2 {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;

      & > [class|="our"] {
        margin-right: 1rem;
      }
    }

    .double-check-icon {
      display: block;
      margin: .25rem .25rem .25rem 0;
      padding: .25rem .5rem .75rem 0;
      position: relative;

      &::before {
        content: '\f560';
        color: $info-color;
        font-family: 'Font Awesome 5 Free';
        font-size: .7em;
        font-weight: 900;
      }
      &::after {
        content: attr(data-date);
        color: $grey-darken-2;
        font-size: .7em;
        position: absolute;
        right: calc(50% - 45.5px);
        transform: translateY(22px);
      }
    }
  }

  /*  Animaciones de transición  */
  .slide-fade-enter-active {
    transition: all .5s ease;
  }
  .slide-fade-leave-active {
    transition: all .8s ease;
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
</style>
